import React from "react";

export function RequiredLabel({ label, htmlFor }) {
  return (
    <label htmlFor={htmlFor} className="form-label">
      {label} <span style={{ color: "red" }}>*</span>
    </label>
  );
}
